<template>
  <div class="animated fadeIn">
    <Alerts ref="alert" />
    <Forms
      ref="frmDistribution"
      :title="$lang.Distribution.TitleForms"
      :showHelp="true"
      :showClearButton="true"
      :showSearchButton="true"
      :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
      v-on:Clear="onClear"
      v-on:Search="onSearch"
    >
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxInsure"> * {{ $lang.Sinister.Search.Insurer }}:</label>
          <div class="input-group">
            <v-select
              style="width: 100%"
              multiple
              v-model="form.insurance.value"
              :options="form.insurance.options"
            />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtInsured"> {{ $lang.Sinister.Search.Insured }}:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtInsured"
              :placeholder="$lang.Sinister.Search.PlaceholderEnterInsured"
              v-model="form.insured.value"
              :size="form.insured.maxlength"
              :state="form.insured.state"
            />
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"> {{ $lang.Sinister.Search.Stage }}:</label>
          <div class="input-group">
            <v-select
              style="width: 100%"
              multiple
              v-model="form.stage.value"
              :options="form.stage.options"
            />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtCodeSinister">
            {{ $lang.Sinister.Search.SinisterCode }}:</label
          >
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtCodeSinister"
              :placeholder="$lang.Sinister.Search.PlaceholderEnteSinisterCode"
              v-model="form.sinisterCode.value"
              :size="form.sinisterCode.maxlength"
              :state="form.sinisterCode.state"
            />
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxSchedulingType">Forma da Vistoria:</label>
          <div class="input-group">
            <b-form-select
              id="cbxSchedulingType"
              name="cbxSchedulingType"
              v-model="form.schedulingTypeID.value"
              :options="form.schedulingTypeID.options"
              :state="form.schedulingTypeID.state"
            >
              <template slot="first">
                <option :value="null" disabled>
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDateStart"
            >{{ $lang.Sinister.Search.DateStart }}:</label
          >
          <div class="input-group">
            <datepicker
              name="txtSinisterDateStart"
              v-model="form.sinisterDateStart.value"
              :format="'dd/MM/yyyy'"
              :language="ptBR"
              :placeholder="$lang.Common.DatePlaceholder"
              :clear-button="true"
              :clear-button-icon="'fa fa-close'"
              :calendar-button="true"
              :calendar-button-icon="'fa fa-calendar'"
              :bootstrap-styling="true"
              :full-month-name="true"
              :use-utc="true"
            />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDateEnd">
            {{ $lang.Sinister.Search.DateEnd }}:</label
          >
          <div class="input-group">
            <datepicker
              name="txtSinisterDateEnd"
              v-model="form.sinisterDateEnd.value"
              :format="'dd/MM/yyyy'"
              :language="ptBR"
              :placeholder="$lang.Common.DatePlaceholder"
              :clear-button="true"
              :clear-button-icon="'fa fa-close'"
              :calendar-button="true"
              :calendar-button-icon="'fa fa-calendar'"
              :bootstrap-styling="true"
              :full-month-name="true"
              :use-utc="true"
            />
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxInsure"> {{ $lang.Sinister.Search.Expert }}:</label>
          <div class="input-group">
            <v-select
              style="width: 100%"
              multiple
              v-model="form.expert.value"
              :options="form.expert.options"
            />
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxInsure">{{ $lang.Sinister.Search.Analyst }}:</label>
          <div class="input-group">
            <v-select
              style="width: 100%"
              multiple
              v-model="form.analyst.value"
              :options="getAllAnalyst"
            />
          </div>
        </div>
      </div>
    </Forms>
    <Forms
      ref="frmDistributionTable"
      :title="'LISTA DE PROCESSOS A SEREM DISTRIBUÍDOS'"
    >
      <Tables
        ref="tableGrid"
        :columns="[
          '',
          $lang.Sinister.Search.DataTable.SinisterAndVersion,
          $lang.Sinister.Search.DataTable.Insurer,
          $lang.Sinister.Search.DataTable.Date,
          $lang.Sinister.Search.DataTable.City,
          $lang.Sinister.Search.DataTable.Responsible,
          $lang.Sinister.Search.DataTable.MechanicalWorkshop,
          $lang.Sinister.Search.DataTable.SurveyWay,
          $lang.Sinister.Search.Analyst,
          $lang.Sinister.Search.Expert,
        ]"
        :showSearch="false"
        :showPrint="false"
        :showDownload="false"
        :showFullscreen="false"
        :messageTipFooter="$lang.Common.ClickToSelect"
        v-on:Load="onSearch"
        v-on:Fullscreen="onFullscreen"
      >
        <tr v-for="obj in this.objList" v-bind:key="obj.ID">
          <td>
            <input type="checkbox" v-model="obj.isChecked" />
          </td>
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.status"
            :value="`${obj.sinisterCode} - ${obj.sinisterVersion}`"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.status"
            :value="obj.insurance.name"
          />
          <TableColumn
            :IsDatetime="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.status"
            :value="obj.sinisterDate"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.status"
            :value="null"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.status"
            :value="obj.responsible.name"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.status"
            :value="obj.mechanicalWorkshop.name"
          />
          <TableColumn
            :IsText="true"
            style="font-weight: bold"
            v-on:Edit="onEdit(obj)"
            :status="obj.status"
            :value="obj.schedulingTypeString"
          />
          <td>
            <b-form-select
              name="cbxAnalyst"
              v-model="obj.analystID"
              :options="obj.analysts"
              text-field="label"
              @change="onSelectAnalyst(obj)"
            >
              <template slot="first">
                <option :value="undefined" disabled>
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </td>
          <td>
            <b-form-select
              name="cbxExpert"
              v-model="obj.expertID"
              :options="obj.experts"
              text-field="label"
              @change="onSelectExpert(obj)"
            >
              <template slot="first">
                <option :value="undefined" disabled>
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </td>
        </tr>
      </Tables>
    </Forms>
    <div class="form-group row">
      <div class="col-md-12 text-center">
        <button
          type="button"
          class="btn btn-third btn-sm text-secundary"
          @click="distribute"
        >
          <i class="fa fa-minus-circle"></i> Distribuir Processos
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Distribution from './distribution.js'

export default Distribution
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/distribution/distribution.vue